import React, { type ComponentProps } from 'react';

import { cssMap } from '@compiled/react';
// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint, LazySuspense, type LazyComponent } from 'react-loosely-lazy';

import { Box } from '@atlaskit/primitives/compiled';
import { I18nProvider } from '@atlassian/embedded-confluence-common/i18n/i18n-provider';
import { EMBEDDED_CONFLUENCE_MODE } from '@atlassian/embedded-confluence-common/page-common/EmbeddedConfluenceMode';
import { PerformanceMetricsProvider } from '@atlassian/embedded-confluence-common/performance-metrics/performanceMetricsProvider';

import fetchTranslations from '../i18n/fetchTranslations';

const styles = cssMap({
	fallback: {
		width: '100%',
		height: '100%',
	},
});

const LazyEmbeddedConfluence: LazyComponent<(props: any) => React.JSX.Element> = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_embedded-confluence-view-page" */
			'./EmbeddedConfluence'
		),
);

export type EmbeddedConfluenceProps = ComponentProps<typeof LazyEmbeddedConfluence> & {
	locale?: string;
};

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const EmbeddedConfluence = (props: EmbeddedConfluenceProps): React.JSX.Element => (
	<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
		<PerformanceMetricsProvider
			contentType={props.mode === EMBEDDED_CONFLUENCE_MODE.EDIT_MODE ? 'editPage' : 'viewPage'}
			sourceComponent={'EmbeddedConfluence'}
		>
			<LazySuspense fallback={<Box xcss={styles.fallback}></Box>}>
				<LazyEmbeddedConfluence {...props} />
			</LazySuspense>
		</PerformanceMetricsProvider>
	</I18nProvider>
);
